var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.76584 2.13254C2.62361 2.01635 2.43037 1.99464 2.26746 2.07623C2.10478 2.15759 2.00092 2.32841 2 2.51616V21.5104C2.00092 21.6979 2.10455 21.8687 2.26723 21.9501C2.43014 22.0317 2.62338 22.0099 2.76538 21.8938L14.352 12.3967C14.465 12.3041 14.531 12.1629 14.531 12.0133C14.531 11.8637 14.465 11.7224 14.352 11.6299L2.76584 2.13254Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3534 2H21.5298C21.7896 2 22.0003 2.21877 22.0003 2.4886V21.4828C22.0003 21.7526 21.7896 21.9714 21.5298 21.9714H17.3534C17.0935 21.9714 16.8828 21.7526 16.8828 21.4828V2.4886C16.8828 2.21877 17.0935 2 17.3534 2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextVideo);
export default __webpack_public_path__ + "static/media/nextVideo.ba2f1f7b704a18e1f51e334d10ae0945.svg";
export { ForwardRef as ReactComponent };